module.exports = __webpack_public_path__ + "static/media/double-right.a0427aba.png";